import apiHandler from "./apiHandler";

import { defaultPagination } from "@/utils/helpers";

const apiAirlines = {
  byId: (id) => {
    return new Promise((resolve, reject) => {
      apiHandler
        .get("/airline/" + id)
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  pilotStatus: (id) => {
    return new Promise((resolve, reject) => {
      apiHandler
        .get("/airline/" + id + "/pilotstatus")
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  settings: {
    get: (airline) => {
      return new Promise((resolve, reject) => {
        // defaultPagination(pagination);
        apiHandler
          .get(`/airline/${airline._id}/settings`)
          .then((response) => {
            resolve(response.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    set: (airline, settings) => {
      return new Promise((resolve, reject) => {
        // defaultPagination(pagination);
        apiHandler
          .patch(`/airline/${airline._id}/settings`, {
            settings: settings,
          })
          .then((response) => {
            resolve(response.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
  create: (payload) => {
    return new Promise((resolve, reject) => {
      apiHandler
        .post("/airline", payload)
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  update: (payload) => {
    return new Promise((resolve, reject) => {
      apiHandler
        .patch("/airline", payload)
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  delete: (id, fullname) => {
    return new Promise((resolve, reject) => {
      apiHandler
        .delete("/airline", {
          id: id,
          fullname: fullname,
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  fetch: (pagination, needle) => {
    return new Promise((resolve, reject) => {
      defaultPagination(pagination);
      apiHandler
        .post("/airline/search", {
          skip: (pagination.page - 1) * pagination.rowsPerPage,
          count: pagination.rowsPerPage,
          needle: needle,
          sort: pagination.sortBy !== null ? pagination.sortBy : "",
          order: pagination.descending ? -1 : 1,
        })
        .then((response) => {
          pagination.rowsNumber = response.data.totalResults;
          resolve({
            results: response.data.results,
            pagination,
          });
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  join: (airline) => {
    return new Promise((resolve, reject) => {
      apiHandler
        .get("/airline/" + airline._id + "/join")
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  leave: (airline, reason) => {
    return new Promise((resolve, reject) => {
      apiHandler
        .post("/airline/" + airline._id + "/leave", { reason })
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  myAirlines: () => {
    return new Promise((resolve, reject) => {
      apiHandler
        .get("/airline/my")
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  airports: {
    fetchOne: (airline, icao) => {
      return new Promise((resolve, reject) => {
        apiHandler
          .get(`/airline/${airline._id}/airport/${icao}`)
          .then((response) => {
            resolve(response.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    fetch: (airline, pagination, needle) => {
      return new Promise((resolve, reject) => {
        defaultPagination(pagination);
        apiHandler
          .post(`/airline/${airline._id}/airports`, {
            skip: (pagination.page - 1) * pagination.rowsPerPage,
            count: pagination.rowsPerPage,
            needle: needle,
            sort: pagination.sortBy !== null ? pagination.sortBy : "",
            order: pagination.descending ? -1 : 1,
          })
          .then((response) => {
            pagination.rowsNumber = response.data.totalResults;
            resolve({
              results: response.data.results,
              pagination,
            });
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    addOrUpdate: (airline, airport) => {
      return new Promise((resolve, reject) => {
        apiHandler
          .put(`/airline/${airline._id}/airport`, {
            airport: {
              icao: airport.icao,
              networkId: airport.networkId,
              home: airport.home,
              hub: airport.hub,
              rates: airport.rates,
              gates: airport.gates,
            },
          })
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    delete: (airline, airport) => {
      return new Promise((resolve, reject) => {
        apiHandler
          .delete(`/airline/${airline._id}/airport/${airport.icao}`)
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
  pilots: {
    details: (airline, pilot_id, showErrors = true) => {
      return new Promise((resolve, reject) => {
        apiHandler
          .get("/airline/" + airline._id + "/pilot/" + pilot_id, { showErrors })
          .then((response) => {
            resolve(response.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    fetch: (
      airline,
      pagination,
      needle,
      status = "all",
      includeSensitive = false,
    ) => {
      return new Promise((resolve, reject) => {
        defaultPagination(pagination);
        apiHandler
          .post("/airline/" + airline._id + "/pilots", {
            skip: (pagination.page - 1) * pagination.rowsPerPage,
            count: pagination.rowsPerPage,
            needle: needle,
            sort: pagination.sortBy !== null ? pagination.sortBy : "",
            order: pagination.descending ? -1 : 1,
            status,
            includeSensitive,
          })
          .then((response) => {
            pagination.rowsNumber = response.data.totalResults;
            resolve({
              results: response.data.results,
              pagination,
            });
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    update: (airline, pilot, status, permissions, reason) => {
      return new Promise((resolve, reject) => {
        apiHandler
          .patch(`/airline/${airline._id}/pilot/${pilot._id}`, {
            pilot: {
              status,
              permissions,
            },
            reason,
          })
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    delete: (airline, pilot, reason) => {
      return new Promise((resolve, reject) => {
        apiHandler
          .delete(`/airline/${airline._id}/pilot/${pilot._id}`, {
            reason,
          })
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
  aircraft: {
    details: (id) => {
      return new Promise((resolve, reject) => {
        apiHandler
          .get("/aircraft/" + id)
          .then((response) => {
            resolve(response.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    fetch: (airline, pagination, needle) => {
      return new Promise((resolve, reject) => {
        defaultPagination(pagination);
        apiHandler
          .post(`/airline/${airline._id}/aircraft/list`, {
            skip: (pagination.page - 1) * pagination.rowsPerPage,
            count: pagination.rowsPerPage,
            needle: needle,
            sort: pagination.sortBy !== null ? pagination.sortBy : "",
            order: pagination.descending ? -1 : 1,
          })
          .then((response) => {
            pagination.rowsNumber = response.data.totalResults;
            resolve({
              results: response.data.results,
              pagination,
            });
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    fetchAirframes: (airline) => {
      return new Promise((resolve, reject) => {
        let url = "/airframes";
        if (airline !== undefined) {
          url = `/airline/${airline._id}/airframes`;
        }
        apiHandler
          .get(url)
          .then((response) => {
            resolve(response.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    fetchAirframe: (icao) => {
      return new Promise((resolve, reject) => {
        apiHandler
          .get(`/airframe/${icao}`)
          .then((response) => {
            resolve(response.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    fetchAvailable: (
      airline,
      airframes,
      needle,
      depIcao,
      freeFlight = false,
      charter = false,
      purpose = "pax",
    ) => {
      return new Promise((resolve, reject) => {
        apiHandler
          .post(`/airline/${airline._id}/available/aircraft`, {
            airframes,
            needle,
            depIcao,
            freeFlight,
            charter,
            purpose,
          })
          .then((response) => {
            resolve(response.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    lease: (airline, aircraft) => {
      return new Promise((resolve, reject) => {
        apiHandler
          .post(`/airline/${airline._id}/aircraft`, aircraft)
          .then((response) => {
            resolve(response.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    update: (airline, aircraft) => {
      return new Promise((resolve, reject) => {
        apiHandler
          .patch(`/airline/${airline._id}/aircraft`, aircraft)
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    delete: (airline, aircraft) => {
      return new Promise((resolve, reject) => {
        apiHandler
          .delete(`/airline/${airline._id}/aircraft/${aircraft._id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
  operations: {
    airports: (airline) => {
      return new Promise((resolve, reject) => {
        apiHandler
          .get("/airline/" + airline._id + "/operations/airports")
          .then((response) => {
            resolve(response.data.results);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    schedules: (airline) => {
      return new Promise((resolve, reject) => {
        apiHandler
          .get("/airline/" + airline._id + "/operations/schedules")
          .then((response) => {
            resolve(response.data.results);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    aircraft: (airline) => {
      return new Promise((resolve, reject) => {
        apiHandler
          .get("/airline/" + airline._id + "/operations/aircraft")
          .then((response) => {
            resolve(response.data.results);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
  awards: {
    fetch: (
      airline,
      pagination,
      needle,
      activeOnly = true,
      showClosed = false,
    ) => {
      return new Promise((resolve, reject) => {
        defaultPagination(pagination);
        apiHandler
          .post(`/airline/${airline._id}/awards`, {
            skip: (pagination.page - 1) * pagination.rowsPerPage,
            count: pagination.rowsPerPage,
            needle: needle,
            sort: pagination.sortBy !== null ? pagination.sortBy : "",
            order: pagination.descending ? -1 : 1,
            activeOnly,
            showClosed,
          })
          .then((response) => {
            pagination.rowsNumber = response.data.totalResults;
            resolve({
              results: response.data.results,
              pagination,
            });
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    create: (award) => {
      return new Promise((resolve, reject) => {
        apiHandler
          .post(`/award`, award)
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    update: (id, update) => {
      return new Promise((resolve, reject) => {
        apiHandler
          .patch(`/award/${id}`, update)
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    start: (id) => {
      return new Promise((resolve, reject) => {
        apiHandler
          .patch(`/award/${id}/start`)
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    close: (id) => {
      return new Promise((resolve, reject) => {
        apiHandler
          .patch(`/award/${id}/close`)
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    delete: (id) => {
      return new Promise((resolve, reject) => {
        apiHandler
          .delete(`/award/${id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
  webhooks: {
    types: () => {
      return new Promise((resolve, reject) => {
        // defaultPagination(pagination);
        apiHandler
          .get(`/airline/webhook/types`)
          .then((response) => {
            resolve(response.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    create: (airline, type, url, target, template) => {
      return new Promise((resolve, reject) => {
        // defaultPagination(pagination);
        apiHandler
          .post(`/airline/${airline._id}/webhook/create`, {
            type,
            url,
            target,
            template,
          })
          .then((response) => {
            resolve(response.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    delete: (airline, id) => {
      return new Promise((resolve, reject) => {
        // defaultPagination(pagination);
        apiHandler
          .delete(`/airline/${airline._id}/webhook/delete/${id}`)
          .then((response) => {
            resolve(response.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    list: (airline) => {
      return new Promise((resolve, reject) => {
        // defaultPagination(pagination);
        apiHandler
          .get(`/airline/${airline._id}/webhook/list`)
          .then((response) => {
            resolve(response.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
};

export default apiAirlines;
